import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {ComplexTypeOperator} from 'data-types/benchling-type-def/ComplexTypes';
import {LookupConfigSpec} from 'lookup-config/LookupConfigModalConstants';

export const enum BenchlingExpressionType {
  CONSTANT_VALUE = 'CONSTANT_VALUE',
  CONTEXT_VARIABLE = 'CONTEXT_VARIABLE',
  SCHEMA_LOOKUP = 'SCHEMA_LOOKUP',
  FUNCTION = 'FUNCTION',
}

interface ListItemType {
  name: ComplexTypeOperator.LIST;
  ofType: LeafType;
  selectorId?: string | null;
}

interface ScalarItemType {
  name: LeafType;
  selectorId?: string | null;
}

type ItemType = ScalarItemType | ListItemType;

export interface BenchlingExpressionConstantValue {
  type: BenchlingExpressionType.CONSTANT_VALUE;
  itemType: ItemType;
  value: unknown;
}

export interface BenchlingExpressionContextVariable {
  type: BenchlingExpressionType.CONTEXT_VARIABLE;
  itemType: ItemType;
  contextKey: string;
}

export interface BenchlingExpressionSchemaLookup {
  type: BenchlingExpressionType.SCHEMA_LOOKUP;
  schema: string;
  lookupConfig: LookupConfigSpec;
  expression: BenchlingExpression;
}

export interface BenchlingExpressionFunctionParameter {
  name: string;
  expression: BenchlingExpression;
}

export interface BenchlingExpressionFunction {
  type: BenchlingExpressionType.FUNCTION;
  name: string;
  parameters: Array<BenchlingExpressionFunctionParameter>;
}

export type BenchlingExpression =
  | BenchlingExpressionConstantValue
  | BenchlingExpressionContextVariable
  | BenchlingExpressionSchemaLookup
  | BenchlingExpressionFunction;
